import React from 'react'
import { Link, Text } from '@chakra-ui/react'

export const DocumentLink = ({
  url,
  textContent,
}: {
  url: string
  textContent: string
}) => (
  <Link
    target="_blank"
    href={url}
    sx={{
      ':hover': {
        color: 'apex.black',
        textDecoration: 'none',
      },
    }}
  >
    <Text>{textContent}</Text>
  </Link>
)
